<template>
  <div class="row align-items-center dl-Deal_Tile py-2">
    <div class="col flex-shrink-0 flex-grow-1">
      <div class="h6 mb-0">{{ title }}</div>
      <p v-if="description" class="text-sm mt-1 mb-0">{{ description }}</p>
      <div v-if="attributes.length" class="mt-1">
        <BadgeGroup>
          <Badge
            :key="`attribute-${index}`"
            :variant="badgeVariant(Object.keys(attribute)[0])"
            v-for="(attribute, index) in attributes"
            :text="Object.values(attribute)[0]"
          />
        </BadgeGroup>
      </div>
      <div v-if="allergies" class="mt-1 d-flex align-items-center">
        <p class="mb-0 text-xs text-muted">
          {{ allergies }}
        </p>
        <button v-open-modal="'lunchMenuAllergens'" class="btn btn-sm btn-reset">
          <CircleInfo class="svg-16 svg-fill-gray-600" />
        </button>
      </div>
    </div>
    <div class="col flex-shrink-0 flex-grow-0 text-sm-right">
      <div class="h4 mb-0 text-nowrap">
        {{ price | currency }}
      </div>
    </div>
  </div>
</template>

<script>
import CircleInfo from "../../icons/atalanda/circle-info.svg";
import BadgeGroup from "./BadgeGroup.vue";
import Badge from "./Badge.vue";

export default {
  name: "LunchMenuItem",
  components: {
    Badge,
    BadgeGroup,
    CircleInfo,
  },
  props: {
    attributes: {
      type: Array,
      required: false,
      default: () => [],
    },
    price: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: "",
    },
    allergies: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    badgeVariant(variant) {
      switch (variant) {
        case "VEGAN":
        case "VEGETARIAN":
          return "green";
        case "GLUTENFREE":
          return "orange";
        default:
          return "";
      }
    },
  },
};
</script>
